/**
 * JavaScript Utility - isNull
 * @author 서명환 <mhseo@ulalalab.com>
 */
function isNull(value) {
  return value === null || typeof value === 'undefined';
}

export default isNull;
